'use client';

import { Container } from '..';
import { H1_OPT } from './styleConstants';
import { TestCard } from './TestCard';
import PackagesData from './testsData.json';
import { useEffect, useState } from 'react';
import styles from './BloodTestSection.module.css';

export const BloodTestSection = ({ className }: { className?: string }) => {
  const [packageContent, setPackageContent] = useState<Array<any>>([]);
  const [activePackage, setActivePackage] = useState('');

  const { tests } = PackagesData;

  useEffect(() => {
    setActivePackage(tests[0]?.title);
  }, []);

  useEffect(() => {
    const activePackageData = tests?.find(
      (test: any) => test?.title === activePackage,
    );
    if (activePackageData?.packages) {
      setPackageContent(activePackageData?.packages);
    }
  }, [activePackage]);

  const onTabClick = (e: any) => {
    if (e?.target?.innerText) {
      setActivePackage(e?.target?.innerText);
    }
  };

  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <div className={styles.mainContent}>
          <H1_OPT>All Blood Tests</H1_OPT>
          <div className={`${styles.tabs} u-hide-scrollbar`}>
            {tests?.map((param: any, idx: number) => {
              return (
                <button
                  className={styles.tab}
                  id={param?.title}
                  key={idx}
                  onClick={onTabClick}
                  style={{
                    color:
                      activePackage === param?.title ? '#000000' : '#00000066',
                    borderBottom:
                      activePackage === param?.title
                        ? '1px solid #000000'
                        : 'none',
                  }}
                >
                  {param?.title}
                </button>
              );
            })}
          </div>
          <div className={styles.testCards}>
            {packageContent.map((pack: any, idx: number) => {
              return <TestCard packageData={pack} key={idx} />;
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};
